/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';
import { borderWidth, padding } from 'polished';

type Props = {
  bare?: boolean,
  bold?: boolean,
  borderLeft?: boolean,
  borderRight?: boolean,
  children?: React.Node,
  className?: string,
  noWrap?: boolean,
  squish?: boolean,
  textAlign?: 'left' | 'right' | 'center'
};

const defaultProps = {
  bare: false,
  bold: false,
  borderLeft: false,
  borderRight: false,
  children: undefined,
  className: undefined,
  noWrap: false,
  squish: false,
  textAlign: 'left'
};

const Cell = styled.div(
  ({ theme }) => ({
    alignItems: 'stretch',
    borderColor: theme.color.basis5,
    borderStyle: 'solid',
    ...borderWidth(1, 0),
    display: 'table-cell',
    minWidth: 0,
    ...padding('0.5em', 0),
    verticalAlign: 'middle'
  }),
  ({ theme, squish }) =>
    squish
      ? {
          [theme.mediaQuery.desktopOnly]: {
            display: 'none'
          }
        }
      : undefined,
  ({ textAlign }) => ({
    textAlign
  })
);

const CellInner = styled.div(
  ({ theme }) => ({
    alignItems: 'center',
    borderColor: theme.color.basis6,
    borderStyle: 'solid',
    borderWidth: 0,
    display: 'flex',
    flexBasis: '100%',
    minWidth: 0
  }),
  ({ borderLeft }) => ({
    borderLeftWidth: borderLeft ? 1 : 0
  }),
  ({ borderRight }) => ({
    borderRightWidth: borderRight ? 1 : 0
  })
);

const Text = styled.div(
  {
    flexBasis: '100%'
  },
  ({ noWrap }) =>
    noWrap
      ? {
          maxWidth: '7rem',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }
      : undefined,
  ({ bold, theme }) =>
    bold
      ? {
          fontWeight: theme.fontWeight.demiBold
        }
      : undefined
);

function PlayerCell({
  bare,
  bold,
  borderLeft,
  borderRight,
  children,
  className,
  noWrap,
  squish,
  textAlign
}: Props) {
  return (
    <Cell className={className} squish={squish} textAlign={textAlign}>
      <CellInner bare={bare} borderLeft={borderLeft} borderRight={borderRight}>
        <Text noWrap={noWrap} bold={bold}>
          {children}
        </Text>
      </CellInner>
    </Cell>
  );
}

PlayerCell.defaultProps = defaultProps;

export default PlayerCell;
